import { Routes } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { SignUpEffects } from './sign-up/state/effects/sign-up.effects';
import { unAuthorizeGuard } from '../../core/guards/unauthorize.guard';

export const AUTH_ROUTES: Routes = [
  {
    path: 'auth/login',
    canActivate: [unAuthorizeGuard],
    loadComponent: () => import('./login/login.component').then(c => c.LoginComponent),
  },
  {
    path: 'auth/forgot-password',
    canActivate: [unAuthorizeGuard],
    loadComponent: () => import('./forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent),
  },
  {
    path: 'auth/change-password',
    canActivate: [unAuthorizeGuard],
    loadComponent: () => import('./change-password/change-password.component').then(c => c.ChangePasswordComponent),
  },
  {
    path: 'invite',
    canActivate: [unAuthorizeGuard],
    loadComponent: () => import('./change-password/change-password.component').then(c => c.ChangePasswordComponent),
  },
  {
    path: 'auth/sign-up',
    // canActivate: [unAuthorizeGuard],
    loadComponent: () => import('./sign-up/sign-up.component').then(modules => modules.SignUpComponent),
    providers: [provideEffects(SignUpEffects)],
  },
  {
    path: 'auth',
    loadComponent: () => import('./login/login.component').then(c => c.LoginComponent),
  },
];
